import { useState, type ReactNode, type FormEvent } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../auth/AuthProvider.js';
import { useTranslation } from '../../../../shared/i18n/index.js';

export function MfaVerifyPage(): ReactNode {
  const { verifyMfa, mfaChallengeId } = useAuth();
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [code, setCode] = useState('');
  const [error, setError] = useState<string | null>(null);

  async function onSubmit(e: FormEvent) {
    e.preventDefault();
    setError(null);
    if (!/^\d{6}$/.test(code)) { setError(t('auth.mfa.verify.invalidCode')); return; }
    try {
      await verifyMfa(code);
      navigate('/dashboard');
    } catch (err) {
      setError((err as Error).message || t('auth.login.otp.verifyFailed'));
    }
  }

  return (
    <main aria-label="mfa-verify">
      <h1>{t('auth.mfa.verify.title')}</h1>
      {mfaChallengeId ? null : <p role="alert">{t('auth.mfa.verify.noChallenge')}</p>}
      <form onSubmit={onSubmit} aria-label="mfa-form">
        <label htmlFor="mfa-code">{t('auth.mfa.verify.codeLabel')}</label>
        <input id="mfa-code" inputMode="numeric" maxLength={6} value={code} onChange={(e) => setCode(e.target.value)} />
        {error ? <p role="alert">{error}</p> : null}
        <button type="submit">{t('auth.mfa.verify.verify')}</button>
      </form>
    </main>
  );
}
